/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { UnitDependencies } from './dependenciesUnitClass.generated';
import { NodeDependencies } from './dependenciesNode.generated';
import { createSymbolNode } from '../../factoriesAny.js';
export var SymbolNodeDependencies = {
  UnitDependencies: UnitDependencies,
  NodeDependencies: NodeDependencies,
  createSymbolNode: createSymbolNode
};